import React from 'react'
import Navbar from '../components/Navbar/Navbar'
import Footer from '../components/Footer/Footer'
import Householdheader from '../components/Servicelist/Householdheader'
import HouseholdJunkRemoval from '../components/Servicelist/HouseholdJunkRemoval'

const HouseholdheaderPage = () => {
  return (
    <div>
        <Navbar/>
        <Householdheader/>
        <HouseholdJunkRemoval/>


        <Footer/>
    </div>
  )
}

export default HouseholdheaderPage